import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ simple = false }) => {
  if (simple) {
    return (
      <footer>
        <div className="container">
          <div className="row mt-n4 mb-4 pb-4 border-bottom border-color-light-white">
            {/*<div className="col-lg-4 mt-4 text-center">
              <h3 className="footer-title-style text-white">Phone</h3>
              <p className="mb-0">(+91) 123 456 789</p>
            </div>*/}
            <div className="col-lg-6 mt-6 text-center">
              <h3 className="footer-title-style text-white">Email</h3>
              <p className="mb-0">info@sourceerp.in</p>
            </div>
            <div className="col-lg-6 mt-6 text-center">
              <h3 className="footer-title-style text-white">Location</h3>
              <p className="mb-0">No.1204, 12th floor, Manjeera Trinity Corporate, JNTU-Hitech City Road , Hyderabad, Telangana - 500072.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center">
              <ul className="social-icon03 mb-0 ps-0">
                <li><a href="#!"><i className="fab fa-facebook-f"></i></a></li>
                <li><a href="#!"><i className="fab fa-twitter"></i></a></li>
                <li><a href="#!"><i className="fab fa-dribbble"></i></a></li>
                <li><a href="#!"><i className="fab fa-linkedin-in"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bar bg-very-dark">
          <div className="container">
            <p>© <span className="current-year">2026</span> Source-ERP. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="footer-style3 mt-5 bg-white bg-img cover-background" style={{ backgroundImage: 'url(/img/bg/footer.png)' }}>
      <div className="container lg-container">
        <div className="footer-5">
          <div className="row">
            <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
              <span className="footer-logo d-inline-block">
                <img src="/img/logos/logo-footer-small-white.png" alt="Source-ERP" />
              </span>
              <ul className="ps-0">
                <li><i className="fa-solid fa-location-dot"></i> No.1204, 12th floor,  <br />Manjeera Trinity Corporate,
                <br />JNTU-Hitech City Road , Hyderabad, <br /> Telangana - 500072.</li>
                {/*<li><i className="fa-solid fa-phone"></i> +91 98480 12345</li>*/}
                <li><i className="ti-email"></i> <a href="mailto:info@sourceerp.in">info@sourceerp.in</a></li>
              </ul>
              <div className="footer-icon">
                <ul className="mb-0 ps-0">
                  <li><a href="#!"><i className="fab fa-linkedin-in"></i></a></li>
                  <li><a href="#!"><i className="fab fa-twitter"></i></a></li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 mb-5 mb-lg-0">
              <h3>Company</h3>
              <ul className="mb-0 ps-0">
                <li><Link to="/about">About Us</Link></li>
                <li><a href="#!">Our Team</a></li>
                <li><Link to="/services">Services</Link></li>
                <li><a href="#!">Careers</a></li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 mb-5 mb-md-0">
              <h3>Services</h3>
              <ul className="mb-0 ps-0">
                <li><a href="#!">Dynamics 365</a></li>
                <li><a href="#!">CRM Solutions</a></li>
                <li><a href="#!">ERP Implementation</a></li>
                <li><a href="#!">Consulting & Support</a></li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6">
              <h3>Quick Links</h3>
              <ul className="mb-0 ps-0">
                <li><Link to="/contact">Contact Us</Link></li>
                <li><a href="#!">Privacy Policy</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-style3-bottom">
        <div className="container">
          <p>&copy; 2026 Source-ERP. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
